import * as i0 from "@angular/core";
var EditToolService = /** @class */ (function () {
    function EditToolService() {
    }
    EditToolService.prototype.transformLeftRightColumnsToNeutral = function (columns) {
        var neutralCols = [];
        columns.forEach(function (c) {
            if (c.prop.endsWith('_l') || c.prop.endsWith('_r')) {
                var propWithoutDirection_1 = c.prop.substring(0, c.prop.length - 2);
                var lastSpaceIdx = c.name.lastIndexOf(' ');
                var neutralName = c.name.substring(0, lastSpaceIdx);
                var col = neutralCols.find(function (fc) { return fc.propWithoutDirection === propWithoutDirection_1; });
                if (!col) {
                    col = {
                        leftProp: null,
                        leftName: null,
                        rightProp: null,
                        rightName: null,
                        neutralName: neutralName,
                        propWithoutDirection: propWithoutDirection_1
                    };
                    neutralCols.push(col);
                }
                if (c.prop.endsWith('_l')) {
                    col.leftProp = c.prop;
                    col.leftName = c.name;
                }
                else {
                    col.rightProp = c.prop;
                    col.rightName = c.name;
                }
            }
        });
        return neutralCols;
    };
    EditToolService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EditToolService_Factory() { return new EditToolService(); }, token: EditToolService, providedIn: "root" });
    return EditToolService;
}());
export { EditToolService };
